









import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAppendToBodyComponent } from '@/interfaces';
import { appendToBody } from '@/directives';
import { isParent } from '@/utils';

@Component({
  name: 'tooltip',
  directives: { appendToBody }
})
export default class TooltipComponent extends Vue implements IAppendToBodyComponent {
  @Prop() public text!: string;
  @Prop() public width!: number | undefined;
  @Prop() public show!: boolean | undefined;

  public hovering = false;

  public get toggle(): HTMLElement | undefined { return this.$refs.toggle as HTMLElement; }
  public get visible(): boolean { return this.show ?? this.hovering; }

  public calculatePosition = (el: HTMLElement, context: Vue, width: number, height: number, top: number, left: number): (() => void) | undefined => {
    el.style.top = `${top + 8}px`;
    el.style.left = `${left - (width / 2) + 2}px`;
    el.style.width = `${this.width}px`;
    return;
  }

  public onMouseMove(e: MouseEvent) {
    if (this.hovering && this.toggle !== undefined && e.target !== null && !isParent(this.toggle, e.target as Node)) {
      this.hovering = false;
    }
  }
}
